module.exports = __webpack_public_path__ + "static/media/logo.f7b8ee59.svg";